import React from 'react';
import { Col, Row, Layout, Divider } from 'antd';

const headerStyle: React.CSSProperties = {
    color: '#090909ff',
    lineHeight: '25px',
    backgroundColor: '#fff',
    paddingLeft: '0px',
    paddingRight: '0px',
};
const dividerStyle: React.CSSProperties = {
    margin: '15px',
};

interface FuelSurchargeRateViewData {
    groupName?: string[] | string | null;
    priceItems: Array<{ fuelSurchargeRate?: number | string | null }>;
}

/**
 * 燃油附加费查看：只展示一个费率（%），金额 = 基础运费 × 费率
 */
const FuelSurchargeRateViewTab: React.FC<{
    renderData: FuelSurchargeRateViewData[];
}> = ({ renderData }) => {
    const { Header, Content } = Layout;
    const rate = renderData?.[0]?.priceItems?.[0]?.fuelSurchargeRate;
    const rateText = rate === null || rate === undefined || rate === '' ? '-' : `${Number(rate).toFixed(2)}%`;
    return (
        <Layout style={{ backgroundColor: '#fff', padding: 15, border: '1px solid #e8e8e8', borderRadius: 5 }}>
            <Header style={headerStyle}>
                <Row justify="start" align="middle">
                    <Col span={24}>
                        <span>Fuel Surcharge Rate/燃油费率</span>
                    </Col>
                </Row>
                <Divider style={dividerStyle} />
            </Header>
            <Content style={{ background: '#fff' }}>
                <Row justify="start" gutter={[16, 0]} align="middle">
                    <Col>
                        <span>燃油附加费 = 基础运费 × {rateText}</span>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
};

export default React.memo(FuelSurchargeRateViewTab);
